module.exports = __webpack_public_path__ + "img/placeholder.074112c1.png";